import { Pipe, PipeTransform } from '@angular/core';
import marked from 'marked';
const renderer = new marked.Renderer();

@Pipe({ name: 'MarkdownToHtml' })
export class MarkdownToHtmlPipe implements PipeTransform {

    constructor() {
        renderer.link = (href, title, text) => {
            return `<a class="link link--primary" target="_blank" href="${href}"> ${text} </a>`;
        };
    }

    public transform(markdown: string, options?: any): string {
        if (markdown == null) return '';
        return marked(markdown, { renderer });
    }

    public static setOptions(options: any): void {
        marked.setOptions(options);
    }
}
